export default {
      id: "ic-report-white-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic-report-white-usage",
      toString: function () {
        return this.url;
      }
    }